import React, { useEffect } from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
  Typography,
} from "@mui/material";

import { useAuth } from "../context/AuthContext";

export default function ClientSelect({ client, setClient }) {
  const { loginType } = useAuth();

  useEffect(() => {
    if (loginType === "pos" && client !== "giva") {
      setClient("giva");
    }
  }, [loginType, client, setClient]);

  const handleChange = (e) => {
    const value = e.target.value;
    setClient(value === "none" ? null : value);
  };

  return (
    <FormControl component="fieldset" fullWidth>
      <Stack>
        <FormLabel component="legend" sx={{ fontSize: "0.75rem", mb: -1, mt: 0 }}>
          Client
        </FormLabel>
        <RadioGroup row value={client || "none"} onChange={handleChange}>
          <FormControlLabel
            value="giva"
            control={<Radio size="small" color="primary" />}
            label={<Typography sx={{ fontSize: "0.75rem" }}>giva</Typography>}
          />
          {loginType !== "pos" && (
            <FormControlLabel
              value="caratlane"
              control={<Radio size="small" color="primary" />}
              label={<Typography sx={{ fontSize: "0.75rem" }}>caratlane</Typography>}
            />
          )}
        </RadioGroup>
      </Stack>
    </FormControl>
  );
}
